module.exports = __webpack_public_path__ + "media/src/images/kabuka-e643153cc1e25171fea58597d31e7c83.gif";